// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qn0Fl8KQj97_KgUnbJnM {
  position: relative;
}
.Qn0Fl8KQj97_KgUnbJnM::before {
  border-color: transparent;
}

.qDpPo7RmcpB893Jo9eIW {
  color: white;
  font-weight: 700;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.qDpPo7RmcpB893Jo9eIW:hover {
  background-color: #7fac9d; /* Custom hover background */
  color: white; /* Ensure the text stays white */
  border-color: #7fac9d;
}

._tpD21scDTGk8Bx9NMYC {
  height: 2px;
  background-color: #7fac9d; /* Floating indicator color */
  border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,+EAA+E;AACjF;AACA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,YAAY,EAAE,gCAAgC;EAC9C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB,EAAE,6BAA6B;EACxD,kBAAkB;AACpB","sourcesContent":[".list {\n  position: relative;\n}\n.list::before {\n  border-color: transparent;\n}\n\n.tab {\n  color: white;\n  font-weight: 700;\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n.tab:hover {\n  background-color: #7fac9d; /* Custom hover background */\n  color: white; /* Ensure the text stays white */\n  border-color: #7fac9d;\n}\n\n.indicator {\n  height: 2px;\n  background-color: #7fac9d; /* Floating indicator color */\n  border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export var list = `Qn0Fl8KQj97_KgUnbJnM`;
export var tab = `qDpPo7RmcpB893Jo9eIW`;
export var indicator = `_tpD21scDTGk8Bx9NMYC`;
export default ___CSS_LOADER_EXPORT___;
